import { createStyles, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             flexGrow: 1,
//         },
//         label: {
//             marginTop: "1rem"
//         },
//         boldLabel: {
//             marginTop: "1rem",
//             fontWeight: 900
//         }
//     }),
// );

export default function DettagliSrlNonTrasparente(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const { state } = props;
    // const classes = useStyles();

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle style={{ cursor: "pointer" }} className={gClasses.boldLabel} text="S.r.l. non trasparente"></SectionSubTitle>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D27_quota"
                        label="Quota"
                        value={state.dettagli.D27_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E27_contributi"
                        label="Contributi"
                        value={state.dettagli.E27_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D28_quota"
                        label="Quota"
                        value={state.dettagli.D28_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E28_contributi"
                        label="Contributi"
                        value={state.dettagli.E28_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D29_quota"
                        label="Quota"
                        value={state.dettagli.D29_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E29_contributi"
                        label="Contributi"
                        value={state.dettagli.E29_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D30_quota"
                        label="Quota"
                        value={state.dettagli.D30_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E30_contributi"
                        label="Contributi"
                        value={state.dettagli.E30_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D31_quota"
                        label="Quota"
                        value={state.dettagli.D31_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E31_contributi"
                        label="Contributi"
                        value={state.dettagli.E31_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Totale</Typography>
                <NumberField
                    name="D32_quota"
                    label="Quota"
                    value={state.dettagli.D32_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E32_contributi"
                    label="Contributi"
                    value={state.dettagli.E32_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
        </Paper>
    )
}